
function convertDate(string) {
    var date;
    if (string === undefined) {
        date = new Date();
    } else {
        date = new Date(string);
    }
    return date.toLocaleString('en-US');
}

export default convertDate;
